import { render, staticRenderFns } from "./PostGameNotesStep.vue?vue&type=template&id=2baae4ea&scoped=true"
import script from "./PostGameNotesStep.vue?vue&type=script&lang=js"
export * from "./PostGameNotesStep.vue?vue&type=script&lang=js"
import style0 from "./PostGameNotesStep.vue?vue&type=style&index=0&id=2baae4ea&prod&scoped=true&lang=css"
import style1 from "./PostGameNotesStep.vue?vue&type=style&index=1&id=2baae4ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baae4ea",
  null
  
)

export default component.exports